import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/dynamic-sections/AllArticles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/static-sections/Navbar.tsx");
